export type AllProfilesMember = {
  bl_profile: number | null;
  email: string;
  first_name: string;
  last_name: string;
  avatar: string | null;
  sources: string[];
  list_names: string[];
  registration_date: string | null;
  last_visit: string | null;
  perc_watchtime?: string;
  avg_rating?: number;
};

export type PercWatchtimeResponse = {
  bl_profile: number;
  perc_watchtime: string;
};

export type AvgRatingResponse = {
  bl_profile: number;
  avg_rating: number;
};

export enum SortTypes {
  name = 'name',
  source = 'source',
  reg = 'reg',
  lastVisit = 'lastVisit',
  watchtime = 'watchtime',
  rating = 'rating',
}

export enum SortDirection {
  up = 'up',
  down = 'down',
}
